import { Component, EventEmitter, forwardRef, Inject, Input, OnInit, Output } from "@angular/core";
import { ListSnackbarService } from "../../../service/list-snackbar.service";

@Component({
    selector: 'list-snackbar',
    template: require('./list-snackbar.component.html'),
    styles: [require('./list-snackbar.component.css')]
})
export class ListSnackbarComponent implements OnInit {

    @Input() buttons: ListSnackbarButton[];

    @Input() dividerIndexes: number[];

    @Output() buttonClick = new EventEmitter<string>();

    constructor(
        @Inject(forwardRef(() => ListSnackbarService)) private listSnackbarService: ListSnackbarService
    ) { }

    ngOnInit(): void {
        this.listSnackbarService.updateActiveListSnackbar(this);
    }

    performUnselect(): void {
        this.buttonClick.emit('unselect');
    }
}

export class ListSnackbarButton {
    type: ListSnackbarButtonType;
    label: string;
    event?: string;
    icon?: string;
    menuButtons?: MenuButton[];
    disabled?: boolean;
}

export class MenuButton {
    label: string;
    event: string;
    icon?: string;
}

export enum ListSnackbarButtonType {
    SIMPLE = 'SIMPLE',
    SELECTED_ELEMENTS = 'SELECTED_ELEMENTS',
    MENU = 'MENU'
}